var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconJcb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Extra",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-jcb",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28,17.3333333 C28,18.806 26.806,20 25.3333333,20 L2.66666667,20 C1.194,20 0,18.806 0,17.3333333 L0,2.66666667 C0,1.194 1.194,0 2.66666667,0 L25.3333333,0 C26.806,0 28,1.194 28,2.66666667 L28,17.3333333 Z",
    id: "Path",
    fill: "#CFD8DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.11266667,2.66666667 C3.72,2.66666667 2.66666667,3.54933333 2.66666667,5.078 L2.66666667,17.3333333 L6.98866667,17.3333333 C8.076,17.3333333 9.33333333,16.3126667 9.33333333,14.9886667 L9.33333333,2.66666667 L5.11266667,2.66666667 Z",
    id: "Path",
    fill: "#3F51B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1126667,2.66666667 C11.72,2.66666667 10.6666667,3.54933333 10.6666667,5.078 L10.6666667,17.3333333 L14.9886667,17.3333333 C16.076,17.3333333 17.3333333,16.3126667 17.3333333,14.9886667 L17.3333333,2.66666667 L13.1126667,2.66666667 Z",
    id: "Path",
    fill: "#E53935"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1126667,2.66666667 C19.72,2.66666667 18.6666667,3.54933333 18.6666667,5.078 L18.6666667,17.3333333 L22.9886667,17.3333333 C24.076,17.3333333 25.3333333,16.3126667 25.3333333,14.9886667 L25.3333333,2.66666667 L21.1126667,2.66666667 Z",
    id: "Path",
    fill: "#388E3C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.666667, 8.000000)",
    fill: "#FAFAFA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.87066667,2.302 C5.87066667,3.52533333 4.29133333,4.17066667 3.13666667,4.17066667 C1.88066667,4.17066667 0.758666667,3.424 0.519333333,2.474 L1.36866667,2.474 C1.47,3.05133333 2.04933333,3.45733333 2.69333333,3.45733333 C3.40666667,3.45733333 3.916,2.948 3.916,2.30266667 L3.916,0.0953333333 L5.87,0.0953333333 L5.87,2.302 L5.87066667,2.302 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0706667,2.02533333 C21.5786667,2.02533333 21.934,1.51933333 21.934,1.01266667 C21.934,0.504666667 21.492,0.0646666667 20.984,0.0646666667 L16.8093333,0.0646666667 L16.8093333,3.966 L21.0706667,3.966 C21.646,3.966 22.0853333,3.46133333 22.086,2.95333333 C22.086,2.44733333 21.6466667,2.02533333 21.0706667,2.02533333 Z M18.434,0.471333333 L19.7533333,0.471333333 C20.0893333,0.471333333 20.394,0.773333333 20.394,1.11066667 C20.394,1.45 20.0893333,1.75533333 19.7533333,1.75533333 L18.434,1.75533333 L18.434,0.471333333 Z M19.786,3.562 L18.4346667,3.562 L18.4346667,2.27666667 L19.786,2.27666667 C20.1246667,2.27666667 20.4293333,2.58066667 20.4293333,2.92 C20.4293333,3.25666667 20.1246667,3.562 19.786,3.562 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.874,0.784 C13.0953333,0.604 12.35,0.499333333 11.9773333,0.499333333 C11.1653333,0.499333333 10.5233333,1.17733333 10.5233333,2.03466667 C10.5233333,2.896 11.1653333,3.57533333 11.9773333,3.57533333 C12.35,3.57533333 13.0953333,3.504 13.874,3.322 L13.874,4.00266667 L10.624,4.00266667 C9.60933333,4.00266667 8.764,3.108 8.764,2.03466667 C8.764,0.963333333 9.60933333,0.0693333333 10.624,0.0693333333 L13.874,0.0693333333 L13.874,0.784 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconJcb);
export default __webpack_public_path__ + "static/media/icon-jcb.d03ac08d8aba6417f1f1238e8cde7a5d.svg";
export { ForwardRef as ReactComponent };